import { PageListCachedDataSource } from './BaseDataSources';
import { IBuyChannel } from '../Interfaces';

export class BuyChannelSource extends PageListCachedDataSource<IBuyChannel> {
  public constructor() {
    super('/datasource/buychannels');
  }
}